import Vue from 'vue'
import App from './App.vue'
import store from '@/store'
import { router } from '@/plugins/router/download'
// import '@/plugins/vuex'
import '@/utils/axios'
import '@/utils/lodash'
import '@/assets/css/common.styl'
// import '../../registerServiceWorker'
import { Icon, Button, Loading, Overlay, Toast, RadioGroup, Radio, Field, PullRefresh, Dialog } from 'vant'

Vue.use(Icon)
Vue.use(Button)
Vue.use(Loading)
Vue.use(Overlay)
Vue.use(Toast)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(Field)
Vue.use(PullRefresh)
Vue.use(Dialog)
// 动态设置title
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

// console.log(router)
Vue.config.productionTip = false
new Vue({
  store,
  router,
  render: (h) => h(App)
}).$mount('#app')
